var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("pre-label"),
      _vm._v(" "),
      _c("span", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "span",
        _vm._l(_vm.contactList, function (ref, idx) {
          var name = ref.name
          var email = ref.email
          return _c(
            "span",
            {
              key: email,
              staticClass: "text-light-gray font-sm d-inline-block",
            },
            [
              name
                ? _c("span", { staticClass: "bold" }, [_vm._v(_vm._s(name))])
                : _vm._e(),
              _vm._v(" "),
              name
                ? _c("span", [_vm._v("<" + _vm._s(email) + ">")])
                : _c("span", { staticClass: "bold font-sm" }, [
                    _vm._v(_vm._s(email)),
                  ]),
              _vm._v(" "),
              !_vm.isLast(idx)
                ? _c("span", { staticClass: "mr-1" }, [_vm._v(",")])
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }